import "vant/es/toast/style";
import _Toast from "vant/es/toast";
import _Dialoger from "@kibt/meta-ui/es/dialog/dialoger";
import _regeneratorRuntime from "/media/disk1/fordata/jenkins/rbdNodeJs/workspace/SRC/node_modules/@babel/runtime/regenerator";
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
import yoda from '@ks/yoda-js-sdk';
import { toAppLogin } from './outside-login';
import { isInApp } from './yoda';
var i18n = null;
export function setI18n(_i18n) {
  i18n = _i18n;
}
/**
 *
 * @param param0
 * @param confirmButtonText
 *     false     显示toast 默认
 *     true   显示alert 按钮文案 ok 的多语言文案
 *     'xxx'  显示alert 按钮文案 key 为 xxx 的多语言文案
 * @returns
 */
export function handleError(_x) {
  return _handleError.apply(this, arguments);
}
function _handleError() {
  _handleError = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(_ref) {
    var result,
      error_msg,
      error_message,
      errorMsg,
      confirmButton,
      confirmButtonText,
      _confirmButtonText,
      _args4 = arguments;
    return _regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            result = _ref.result, error_msg = _ref.error_msg, error_message = _ref.error_message, errorMsg = _ref.errorMsg;
            confirmButton = _args4.length > 1 && _args4[1] !== undefined ? _args4[1] : '';
            if (i18n) {
              _context4.next = 4;
              break;
            }
            throw new Error('need setI18n first');
          case 4:
            document.documentElement.setAttribute('api', 'error');
            if (!(result === 109 || result === 6002)) {
              _context4.next = 10;
              break;
            }
            _context4.next = 8;
            return new Promise(function (resolve) {
              var _i18n2, _i18n3, _i18n4;
              _Dialoger.alert({
                content: (_i18n2 = i18n) === null || _i18n2 === void 0 ? void 0 : _i18n2.t('common_login_required'),
                okText: isInApp ? (_i18n3 = i18n) === null || _i18n3 === void 0 ? void 0 : _i18n3.t('common_ok') : (_i18n4 = i18n) === null || _i18n4 === void 0 ? void 0 : _i18n4.t('creator_fission_ios_need_login'),
                onOk: function () {
                  var _onOk = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
                    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
                      while (1) {
                        switch (_context2.prev = _context2.next) {
                          case 0:
                            document.documentElement.setAttribute('api', 'ok');
                            if (!isInApp) {
                              _context2.next = 9;
                              break;
                            }
                            _context2.next = 4;
                            return yoda.ready();
                          case 4:
                            _context2.next = 6;
                            return yoda.component.login();
                          case 6:
                            resolve('');
                            _context2.next = 10;
                            break;
                          case 9:
                            toAppLogin();
                          case 10:
                          case "end":
                            return _context2.stop();
                        }
                      }
                    }, _callee2);
                  }));
                  function onOk() {
                    return _onOk.apply(this, arguments);
                  }
                  return onOk;
                }(),
                maskClosable: false
              });
            });
          case 8:
            _context4.next = 23;
            break;
          case 10:
            if (!(result === 11)) {
              _context4.next = 16;
              break;
            }
            confirmButtonText = confirmButton === true ? 'common_ok' : confirmButton.toString();
            _context4.next = 14;
            return new Promise(function (resolve) {
              var _i18n5;
              _Dialoger.alert({
                content: error_msg || error_message || ' ',
                okText: (_i18n5 = i18n) === null || _i18n5 === void 0 ? void 0 : _i18n5.t(confirmButtonText),
                onOk: function () {
                  var _onOk2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
                    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
                      while (1) {
                        switch (_context3.prev = _context3.next) {
                          case 0:
                            _context3.next = 2;
                            return yoda.ready();
                          case 2:
                            yoda.webview.backOrClose();
                            resolve('');
                          case 4:
                          case "end":
                            return _context3.stop();
                        }
                      }
                    }, _callee3);
                  }));
                  function onOk() {
                    return _onOk2.apply(this, arguments);
                  }
                  return onOk;
                }(),
                maskClosable: false
              });
            });
          case 14:
            _context4.next = 23;
            break;
          case 16:
            if (!confirmButton) {
              _context4.next = 22;
              break;
            }
            _confirmButtonText = confirmButton === true ? 'common_ok' : confirmButton;
            _context4.next = 20;
            return new Promise(function (resolve) {
              var _i18n6, _i18n7;
              _Dialoger.alert({
                content: (_i18n6 = i18n) === null || _i18n6 === void 0 ? void 0 : _i18n6.t(error_msg || error_message || errorMsg || 'creator_network_error'),
                okText: (_i18n7 = i18n) === null || _i18n7 === void 0 ? void 0 : _i18n7.t(_confirmButtonText),
                onOk: function onOk() {
                  document.documentElement.setAttribute('api', 'ok');
                  resolve('');
                },
                maskClosable: false
              });
            });
          case 20:
            _context4.next = 23;
            break;
          case 22:
            _Toast(error_msg || error_message || ' ');
          case 23:
            return _context4.abrupt("return", 'refresh');
          case 24:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4);
  }));
  return _handleError.apply(this, arguments);
}
export function createApis(createApisParams) {
  // 生成解决的数组
  var retArray = createApisParams.map(function (api, index) {
    return {
      func: api[0],
      params: api[1],
      ret: null,
      index: index
    };
  });
  var fetch = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var errorArray, apis, againRets;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              res.error = null;
              errorArray = retArray.filter(function (againParam) {
                return !againParam.ret || againParam.ret.result !== 1;
              }); // 说明还有错误或者开始请求
              if (!(errorArray.length > 0)) {
                _context.next = 8;
                break;
              }
              apis = errorArray.map(function (errorRetItem) {
                return errorRetItem.func(errorRetItem.params);
              });
              _context.next = 6;
              return Promise.all(apis);
            case 6:
              againRets = _context.sent;
              // 将错误的或者第一次请求来的ret再次进行赋值
              errorArray.forEach(function (errorItem, index) {
                var _errorItem$ret;
                errorItem.ret = againRets[index];
                var realIndex = errorItem.index;
                res.results[realIndex] = errorItem.ret;
                if (!res.error && ((_errorItem$ret = errorItem.ret) === null || _errorItem$ret === void 0 ? void 0 : _errorItem$ret.result) !== 1) {
                  res.error = errorItem.ret;
                }
              });
            case 8:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));
    return function fetch() {
      return _ref2.apply(this, arguments);
    };
  }();
  // 得事先使用对象，才能保持引用，不然你return{error}，error=againRets[index],这样你就丢失了error
  var res = {
    results: new Array(createApisParams.length),
    error: null,
    fetch: fetch
  };
  return res;
}
// 点击按钮之后的错误处理
// async function btnDemo() {
//     const res = await axios.post('/xxx');
//     if (res.result === 1) {
//         state.data = res;
//     } else if (res.result === 123) {
//         // 个别特殊错误码处理
//         state.xxxx = xxxx;
//     } else {
//         // toast
//         await handleError(res);
//         // alert
//         // await handleError(res, true);
//     }
// }
// <template>
//     <loading v-if="loading">
//     <div v-else-if="data">
//          <empty>
//     </div>
// </template>
// 页面加载时的错误处理
// async function pageDemo() {
//     state.loading = true;
//     // eslint-disable-next-line no-constant-condition
//     // 遇到错误 做重试
//     while (true) {
//         const res = await axios.post('/xxx');
//         // 内部做了处理 只会发一次
//         logger.fmp();
//         if (res.result === 1) {
//             state.data = res;
//             break;
//         } else if (res.result === 123) {
//             // 个别特殊错误码处理
//             state.xxxx = xxxx;
//             break;
//         } else {
//             // 必须是 alert
//             await handleError(res, true);
//             // 点击之后继续
//         }
//     }
//     state.loading = false;
// }